import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElementItem.vue?vue&type=template&id=641ebd8c&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElementItem.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElementItem.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElementItem.vue?vue&type=style&index=0&id=641ebd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ebd8c",
  null
  
)

export default component.exports